/**
 * Identities allowed to override payor panel after discharge and use billing admin tools
 * (clear authorizations, toggle isBilled without normal balance rules).
 */
const SX_BILLING_SUPERUSER_EMAILS = new Set([
 "subhrajoty@radicalhealth.in",
 "sanyam@radicalhealth.in",
 "priti@radicalhealth.in",
 "debjit@radicalhealth.in",
 "jayabrata@radicalhealth.in",
 "swapnadip@radicalhealth.in",
 "soumyadip@radicalhealth.in",
 "bipul@radicalhealth.in",
 "puja@radicalhealth.in",
]);

function normalizeLoginEmail(v) {
 return String(v == null ? "" : v)
  .trim()
  .toLowerCase();
}

/** First email-shaped substring in a display string, e.g. "Name (sanyam@x.com)". */
function extractEmailFromText(s) {
 if (!s || typeof s !== "string") return "";
 const m = s.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
 return m ? m[0].trim().toLowerCase() : "";
}

/** Resolve login email from auth store (API / Auth0 shapes differ). */
export function getSxBillingAuthEmail(authStore) {
 if (!authStore) return "";
 const direct = normalizeLoginEmail(authStore.email);
 if (direct) return direct;
 const userEmail = normalizeLoginEmail(authStore.user?.email);
 if (userEmail) return userEmail;
 const fromName = extractEmailFromText(authStore.name);
 if (fromName) return fromName;
 const name = normalizeLoginEmail(authStore.name);
 if (name.includes("@")) return name;
 return "";
}

export function isSxBillingSuperuser(authStore) {
 const e = getSxBillingAuthEmail(authStore);
 return Boolean(e && SX_BILLING_SUPERUSER_EMAILS.has(e));
}
